"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HmacDRBG = exports.Hash = void 0;
const hash_js_1 = __importDefault(require("hash.js"));
exports.Hash = hash_js_1.default;
const minimalistic_crypto_utils_1 = __importDefault(require("minimalistic-crypto-utils"));
const minimalistic_assert_1 = __importDefault(require("minimalistic-assert"));
class HmacDRBG {
    constructor(options) {
        this.hash = options.hash;
        this.predResist = !!options.predResist;
        this.outLen = this.hash.outSize ?? 0;
        this.minEntropy = (options.minEntropy || this.hash.hmacStrength) ?? 0;
        this._reseed = 0;
        this.reseedInterval = 0;
        this.K = [];
        this.V = [];
        const entropy = minimalistic_crypto_utils_1.default.toArray(options.entropy, options.entropyEnc || 'hex');
        const nonce = minimalistic_crypto_utils_1.default.toArray(options.nonce, options.nonceEnc || 'hex');
        const pers = minimalistic_crypto_utils_1.default.toArray(options.pers, options.persEnc || 'hex');
        (0, minimalistic_assert_1.default)(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
        this._init(entropy, nonce, pers);
    }
    _init(entropy, nonce, pers) {
        const seed = entropy.concat(nonce).concat(pers);
        this.K = new Array(this.outLen / 8);
        this.V = new Array(this.outLen / 8);
        for (let i = 0; i < this.V.length; i++) {
            this.K[i] = 0x00;
            this.V[i] = 0x01;
        }
        this._update(seed);
        this._reseed = 1;
        this.reseedInterval = 0x1000000000000;
    }
    _hmac() {
        return hash_js_1.default.hmac(this.hash, this.K);
    }
    _update(seed) {
        let kmac = this._hmac().update(this.V).update([0x00]);
        if (seed)
            kmac = kmac.update(seed);
        this.K = kmac.digest();
        this.V = this._hmac().update(this.V).digest();
        if (!seed)
            return;
        this.K = this._hmac().update(this.V).update([0x01]).update(seed).digest();
        this.V = this._hmac().update(this.V).digest();
    }
    reseed(...args) {
        const entropy = args[0];
        let entropyEnc = undefined;
        let add = undefined;
        let addEnc = undefined;
        if (typeof args[1] !== 'string') {
            add = args[1];
            addEnc = args[2];
        }
        else {
            entropyEnc = args[1];
            add = args[2];
            addEnc = args[3];
        }
        const actualEntropy = minimalistic_crypto_utils_1.default.toArray(entropy, entropyEnc);
        const actualAdd = minimalistic_crypto_utils_1.default.toArray(add, addEnc);
        (0, minimalistic_assert_1.default)(actualEntropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
        this._update(actualEntropy.concat(actualAdd || []));
        this._reseed = 1;
    }
    generate(...args) {
        if (this._reseed > this.reseedInterval)
            throw new Error('Reseed is required');
        const len = args[0];
        let enc = undefined;
        let add = undefined;
        let addEnc = undefined;
        if (typeof args[1] !== 'string') {
            add = args[1];
            addEnc = args[2];
        }
        else {
            enc = args[1];
            add = args[2];
            addEnc = args[3];
        }
        if (add) {
            add = minimalistic_crypto_utils_1.default.toArray(add, addEnc || 'hex');
            this._update(add);
        }
        let temp = [];
        while (temp.length < len) {
            this.V = this._hmac().update(this.V).digest();
            temp = temp.concat(this.V);
        }
        const res = temp.slice(0, len);
        this._update(add);
        this._reseed++;
        return minimalistic_crypto_utils_1.default.encode(res, enc);
    }
}
exports.HmacDRBG = HmacDRBG;
//# sourceMappingURL=index.js.map